import type { Rule } from "antd/es/form";

export const LOGIN_VALIDATION_MESSAGES = {
	emailRequired: "Please enter your email.",
	emailInvalid: "Please enter a valid email address.",
	passwordRequired: "Please enter your password.",
	invalidCredentials: "Email or password is incorrect.",
} as const;

export const LOGIN_EMAIL_RULES: Rule[] = [
	{ required: true, message: LOGIN_VALIDATION_MESSAGES.emailRequired },
	{ type: "email", message: LOGIN_VALIDATION_MESSAGES.emailInvalid },
];

export const LOGIN_PASSWORD_RULES: Rule[] = [{ required: true, message: LOGIN_VALIDATION_MESSAGES.passwordRequired }];
